import {ActivityI18n} from '@/locales/base.message.locales';

export const activities: ActivityI18n = {
  challenge: {
    abort: 'You left the challenge: {title}',
    accept: 'You accepted the challenge: {title}'
  },
  forum: {
    create: 'You have created a topic called: {topic}, in challenge: {challenge_title}',
    delete: 'You removed the topic: {topic}, from challenge: {challenge_title}'
  },
  task: {
    abort: 'You left the task: {name}, from challenge: {challenge_title}',
    join: 'You accepted the task: {name}, from challenge: {challenge_title}'
  },
  team: {
    accepted: 'You were accepted into the team: {name}, from challenge: {challenge_title}',
    create: 'You created the team: {name}, in challenge: {challenge_title}',
    delete: 'You removed the team: {name}, from challenge: {challenge_title}',
    request: 'You requested to join the team: {name}, from challenge: {challenge_title} '
  },
  user: {
    register: 'You registered'
  }
};
